// extracted by mini-css-extract-plugin
export var box = "_35-0";
export var check = "_35-1";
export var checkboxButton = "_35-6";
export var checkboxGroup = "_35-5";
export var disabled = "_35-7";
export var ghost = "_35-9";
export var input = "_35-2";
export var label = "_35-4";
export var normal = "_35-8";
export var uncheck = "_35-3";